module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/UAywhI/tc-custom/9781426890574.jpg?1728851674165",
      "alt": "This image is the cover for the book In Darkness Bound"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("In Darkness Bound\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In this paranormal romance, three men captive in a mysterious prison are drawn together by their special abilities and their powerful desire for one another.")]), _c('br'), _c('br'), _vm._v("Data Collection by Dalhousie, Dr. Donna L."), _c('br'), _c('br'), _vm._v("Patient 331"), _c('br'), _c('br'), _vm._v("New, confused. Powers unknown."), _c('br'), _c('br'), _vm._v("Patient 289"), _c('br'), _c('br'), _vm._v("No longer viable in the test pool, he remains in isolation."), _c('br'), _c('br'), _vm._v("Patient 77"), _c('br'), _c('br'), _vm._v("Reclassified to staff status. Useful, malleable."), _c('br'), _c('br'), _vm._v("Confined in a sterile research facility and treated like a lab rat, Chris is alone and terrified. His special powers are his only escape, allowing him to psychically connect with other patients."), _c('br'), _c('br'), _vm._v("Alone in his cell for longer than he can remember, Vance is hungry. When newcomer Chris makes a mental connection, Vance is intrigued and wants more than just conversation."), _c('br'), _c('br'), _vm._v("Chris and Vance seek comfort with each other, and with Simon—the only staff member who’s shown them a hint of compassion. Their relationships develop during stolen moments, and they turn their thoughts to escape. But as Dr. Dalhousie’s madness spirals, more than cell walls threaten to keep them apart . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Christine Price\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Carina Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0